<template>
    <!-- 页头组件 -->
    <div class="vel-page-header">
        <!-- 返回 -->
        <span class="vel-page-header-back" @click="goBack">
            <VelIcon class="vel-page-header-back-icon" :iconName="headerIcon" :type="type" />
            <span class="vel-page-header-back-text">返回</span>
        </span>
        <VelLine direction="vertical" />
        <span class="vel-page-header-text">{{headerText}}</span>
    </div>
</template>
<script>
import VelIcon from '../icon'
import VelLine from '../line'
export default {
    name:"VelPageHeader",
    components:{
        VelIcon,
        VelLine
    },
    props:{
        type:String,
        headerIcon:{
            type:String,
            default:'el-icon-d-arrow-left'
        },
        headerText:{
            type:String,
            default:'详情页面'
        }
    },
    data() {
        return {
            
        };
    },
    methods: {
        goBack(){
            this.$router.back()
        }
    }
}
</script>
<style scoped>
.vel-page-header{
    width: 100%;
    font-size: 16px;
}
.vel-page-header-back{
    cursor: pointer;
}
.vel-page-header-back:hover{
    color: #409EFF;
}
.vel-page-header-back-icon{
    color: rgba(0,0,0,.5);
    margin-right: 10px;
}
.vel-page-header-back-text{
    color: rgba(0,0,0,.5);
    margin-right: 10px;
}
.vel-page-header-text{
    margin-left: 10px;
}
</style>